import { Fragment, useCallback, useEffect, useState } from "react";
import Table from "components/Table/Table";
import { UNAUTHORIZED } from "constants";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Pagination from "components/Pagination/Pagination";
import TableSkeleton from "components/Table/TableSkeleton/TableSkeleton";
import { setNavbarTitle } from "features/navbar/navbarSlice";
import { selectAuthUser } from "features/auth/authSlice";
import { actions } from "utils/helpers";
import { toast } from "react-hot-toast";
import {
  useGetPricelistsQuery,
  useDeletePricelistMutation,
} from "features/pricelist/pricelistApiSlice";

import cardStyles from "styles/modules/Card.module.scss";

const Pricelists = ({ label }) => {
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const [searchParams] = useSearchParams();

  const {
    currentData,
    isFetching: isLoading,
    isError,
    error
  } = useGetPricelistsQuery(searchParams.toString());

  const authUser = useSelector(selectAuthUser);

  const [deletePricelist] = useDeletePricelistMutation();

  useEffect(() => {
    dispatch(setNavbarTitle("Pricelists"));
  }, [dispatch]);

  const [errorDisplayed, setErrorDisplayed] = useState(false);

  useEffect(() => {
    if (isError && !errorDisplayed) {
      toast.error(error?.message || "Could not load pricelists, try refreshing the page");
      setErrorDisplayed(true);
    }
  }, [isError, error, errorDisplayed]);


  const onEditBtnHandler = useCallback(
    (id, callFn = false) => {
      if (authUser?.actions[label].includes(actions.view)) {
        if (callFn) {
          navigate(`/pricelists/${id}`);
        }

        return "";
      }

      return UNAUTHORIZED;
    },
    [authUser?.actions, label, navigate]
  );

  const onDeleteBtnHandler = useCallback(
    async (id, callFn = false) => {
      if (authUser?.actions[label].includes(actions.delete)) {
        if (callFn) {
          await deletePricelist(id).unwrap();
        }

        return "";
      }

      return UNAUTHORIZED;
    },
    [authUser?.actions, deletePricelist, label]
  );

  return (
    <div>
      <div className={cardStyles.menu}>
        <h3>Showing data for pricelists</h3>
      </div>
      {isLoading ? (
        <TableSkeleton />
      ) : (
        <Fragment>
          <Table
            data={currentData}
            onEdit={onEditBtnHandler}
            onDelete={onDeleteBtnHandler}
          />
          <Pagination totalCount={currentData?.size} />
        </Fragment>
      )}
    </div>
  );
};

export default Pricelists;
